import { FormikProps } from 'formik'

import NumberField from 'modules/core/components/NumberField'
import i18n from 'modules/core/lib/i18n'

// Generic interface for the minimum required form values
interface DiscountInputFormValues {
  discountPercentage?: number | null
}

interface DiscountInputProps<T extends DiscountInputFormValues> {
  form: FormikProps<T>
  readOnly?: boolean
}

export const DiscountInput = <T extends DiscountInputFormValues>({
  form,
  readOnly = false,
}: DiscountInputProps<T>) => {
  const sanitizeDiscountPercentage = (num: number | null): number =>
    num === null ? 0 : Math.min(Math.abs(num), 100)

  return (
    <NumberField
      readonly={readOnly}
      maxDecimals={2}
      step={readOnly ? 0 : 0.01}
      min={1}
      max={100}
      value={form.values.discountPercentage ?? null}
      placeholder="0"
      label={i18n.t('finance.sale_invoices.form.discount')}
      onChange={(newValue) => {
        const sanitizedValue = sanitizeDiscountPercentage(newValue)

        if (newValue && sanitizedValue !== newValue) {
          form.setFieldError(
            'discountPercentage',
            i18n.t('finance.sale_invoices.form.discount_less_than_or_equal_100')
          )
        } else {
          form.setFieldError('discountPercentage', undefined)
        }

        form.setValues({ ...form.values, discountPercentage: sanitizedValue })
      }}
      // eslint-disable-next-line no-type-assertion/no-type-assertion
      error={form.errors.discountPercentage as string | undefined}
    />
  )
}
